module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_8011.7d4563fc.png";